/**
 * @flow
 * @relayHash aaa161fee2108ce9f3bffb8443152a56
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type PaginatedItemsContainer_items$ref = any;
export type ItemSortField = "BOM_NUMBER" | "CREATED_AT" | "ITEM_NUMBER" | "NAME" | "PART_NUMBER" | "UPDATED_AT";
export type SortDirection = "ASC" | "DESC";
export type ItemSort = {|
  field: ItemSortField,
  direction: SortDirection,
|};
export type PaginatedItemsContainerQueryVariables = {|
  count: number,
  cursor?: ?string,
  search?: ?string,
  sortBy?: ?ItemSort,
  partNumber?: ?string,
  itemNumbers?: ?$ReadOnlyArray<string>,
  orderIds?: ?$ReadOnlyArray<string>,
  customerIds?: ?$ReadOnlyArray<string>,
  itemCategoryIds?: ?$ReadOnlyArray<string>,
|};
export type PaginatedItemsContainerQueryResponse = {|
  +$fragmentRefs: PaginatedItemsContainer_items$ref
|};
export type PaginatedItemsContainerQuery = {|
  variables: PaginatedItemsContainerQueryVariables,
  response: PaginatedItemsContainerQueryResponse,
|};
*/


/*
query PaginatedItemsContainerQuery(
  $count: Int!
  $cursor: String
  $search: String
  $sortBy: ItemSort
  $partNumber: String
  $itemNumbers: [String!]
  $orderIds: [ID!]
  $customerIds: [ID!]
  $itemCategoryIds: [ID!]
) {
  ...PaginatedItemsContainer_items_2fHx2B
}

fragment PaginatedItemsContainer_items_2fHx2B on Query {
  items(first: $count, after: $cursor, search: $search, sortBy: $sortBy, partNumber: $partNumber, itemNumbers: $itemNumbers, orderIds: $orderIds, customerIds: $customerIds, itemCategoryIds: $itemCategoryIds) {
    edges {
      cursor
      ...ItemsTable_itemEdges
      node {
        __typename
        id
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment ItemsTable_itemEdges on ItemEdge {
  node {
    id
    itemNumber
    name
    partNumber
    category {
      id
      name
    }
    quantityUOM {
      id
      symbol
    }
    totalQty
    safetyQuantity
    totalValue
    ...AddUpdateItemModal_item
    ...DeleteItemModal_item
  }
}

fragment AddUpdateItemModal_item on Item {
  id
  name
  upc
  partNumber
  bomNumber
  description
  category {
    id
    name
  }
  quantityUOM {
    id
    name
    type
    symbol
  }
  weightUOM {
    id
    name
    type
    symbol
  }
  dimensionUOM {
    id
    name
    type
    symbol
  }
  form {
    id
    name
    type
    systemKey
    productionType {
      id
    }
    fields {
      id
      systemKey
      type
      name
      description
      placeholder
      isRequired
      isCreatable
      applicationType
      displayOrder
      properties
      options {
        name
        value
        id
      }
      ...AdditionalFieldInfo_formField
    }
  }
  formFieldValues
  dimensionLength
  dimensionWidth
  dimensionHeight
  weight
  lotTracking
  cost
  sellingPrice
  safetyQuantity
  totalValue
  defaultLocation {
    id
    name
  }
}

fragment DeleteItemModal_item on Item {
  id
  name
}

fragment AdditionalFieldInfo_formField on FormField {
  id
  name
  type
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "count",
    "type": "Int!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "cursor",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "search",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "sortBy",
    "type": "ItemSort",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "partNumber",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "itemNumbers",
    "type": "[String!]",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "orderIds",
    "type": "[ID!]",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "customerIds",
    "type": "[ID!]",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "itemCategoryIds",
    "type": "[ID!]",
    "defaultValue": null
  }
],
v1 = {
  "kind": "Variable",
  "name": "customerIds",
  "variableName": "customerIds"
},
v2 = {
  "kind": "Variable",
  "name": "itemCategoryIds",
  "variableName": "itemCategoryIds"
},
v3 = {
  "kind": "Variable",
  "name": "itemNumbers",
  "variableName": "itemNumbers"
},
v4 = {
  "kind": "Variable",
  "name": "orderIds",
  "variableName": "orderIds"
},
v5 = {
  "kind": "Variable",
  "name": "partNumber",
  "variableName": "partNumber"
},
v6 = {
  "kind": "Variable",
  "name": "search",
  "variableName": "search"
},
v7 = {
  "kind": "Variable",
  "name": "sortBy",
  "variableName": "sortBy"
},
v8 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor"
  },
  (v1/*: any*/),
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  },
  (v2/*: any*/),
  (v3/*: any*/),
  (v4/*: any*/),
  (v5/*: any*/),
  (v6/*: any*/),
  (v7/*: any*/)
],
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v11 = [
  (v9/*: any*/),
  (v10/*: any*/)
],
v12 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "symbol",
  "args": null,
  "storageKey": null
},
v13 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "type",
  "args": null,
  "storageKey": null
},
v14 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "description",
  "args": null,
  "storageKey": null
},
v15 = [
  (v9/*: any*/),
  (v10/*: any*/),
  (v13/*: any*/),
  (v12/*: any*/)
],
v16 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "systemKey",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "PaginatedItemsContainerQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "FragmentSpread",
        "name": "PaginatedItemsContainer_items",
        "args": [
          {
            "kind": "Variable",
            "name": "count",
            "variableName": "count"
          },
          {
            "kind": "Variable",
            "name": "cursor",
            "variableName": "cursor"
          },
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/)
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "PaginatedItemsContainerQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "items",
        "storageKey": null,
        "args": (v8/*: any*/),
        "concreteType": "ItemConnection",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "ItemEdge",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "cursor",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Item",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "itemNumber",
                    "args": null,
                    "storageKey": null
                  },
                  (v10/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "partNumber",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "category",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ItemCategory",
                    "plural": false,
                    "selections": (v11/*: any*/)
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "quantityUOM",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "UOM",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      (v12/*: any*/),
                      (v10/*: any*/),
                      (v13/*: any*/)
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "totalQty",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "safetyQuantity",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "totalValue",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "upc",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "bomNumber",
                    "args": null,
                    "storageKey": null
                  },
                  (v14/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "weightUOM",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "UOM",
                    "plural": false,
                    "selections": (v15/*: any*/)
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "dimensionUOM",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "UOM",
                    "plural": false,
                    "selections": (v15/*: any*/)
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "form",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Form",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      (v10/*: any*/),
                      (v13/*: any*/),
                      (v16/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "productionType",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ProductionType",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/)
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "fields",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "FormField",
                        "plural": true,
                        "selections": [
                          (v9/*: any*/),
                          (v16/*: any*/),
                          (v13/*: any*/),
                          (v10/*: any*/),
                          (v14/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "placeholder",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "isRequired",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "isCreatable",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "applicationType",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "displayOrder",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "properties",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "options",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "FormFieldOption",
                            "plural": true,
                            "selections": [
                              (v10/*: any*/),
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "value",
                                "args": null,
                                "storageKey": null
                              },
                              (v9/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "formFieldValues",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "dimensionLength",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "dimensionWidth",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "dimensionHeight",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "weight",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "lotTracking",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "cost",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "sellingPrice",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "defaultLocation",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "WarehouseLocation",
                    "plural": false,
                    "selections": (v11/*: any*/)
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "__typename",
                    "args": null,
                    "storageKey": null
                  }
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "pageInfo",
            "storageKey": null,
            "args": null,
            "concreteType": "PageInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "endCursor",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "hasNextPage",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      },
      {
        "kind": "LinkedHandle",
        "alias": null,
        "name": "items",
        "args": (v8/*: any*/),
        "handle": "connection",
        "key": "PaginatedItemsContainer_items",
        "filters": []
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "PaginatedItemsContainerQuery",
    "id": null,
    "text": "query PaginatedItemsContainerQuery(\n  $count: Int!\n  $cursor: String\n  $search: String\n  $sortBy: ItemSort\n  $partNumber: String\n  $itemNumbers: [String!]\n  $orderIds: [ID!]\n  $customerIds: [ID!]\n  $itemCategoryIds: [ID!]\n) {\n  ...PaginatedItemsContainer_items_2fHx2B\n}\n\nfragment PaginatedItemsContainer_items_2fHx2B on Query {\n  items(first: $count, after: $cursor, search: $search, sortBy: $sortBy, partNumber: $partNumber, itemNumbers: $itemNumbers, orderIds: $orderIds, customerIds: $customerIds, itemCategoryIds: $itemCategoryIds) {\n    edges {\n      cursor\n      ...ItemsTable_itemEdges\n      node {\n        __typename\n        id\n      }\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment ItemsTable_itemEdges on ItemEdge {\n  node {\n    id\n    itemNumber\n    name\n    partNumber\n    category {\n      id\n      name\n    }\n    quantityUOM {\n      id\n      symbol\n    }\n    totalQty\n    safetyQuantity\n    totalValue\n    ...AddUpdateItemModal_item\n    ...DeleteItemModal_item\n  }\n}\n\nfragment AddUpdateItemModal_item on Item {\n  id\n  name\n  upc\n  partNumber\n  bomNumber\n  description\n  category {\n    id\n    name\n  }\n  quantityUOM {\n    id\n    name\n    type\n    symbol\n  }\n  weightUOM {\n    id\n    name\n    type\n    symbol\n  }\n  dimensionUOM {\n    id\n    name\n    type\n    symbol\n  }\n  form {\n    id\n    name\n    type\n    systemKey\n    productionType {\n      id\n    }\n    fields {\n      id\n      systemKey\n      type\n      name\n      description\n      placeholder\n      isRequired\n      isCreatable\n      applicationType\n      displayOrder\n      properties\n      options {\n        name\n        value\n        id\n      }\n      ...AdditionalFieldInfo_formField\n    }\n  }\n  formFieldValues\n  dimensionLength\n  dimensionWidth\n  dimensionHeight\n  weight\n  lotTracking\n  cost\n  sellingPrice\n  safetyQuantity\n  totalValue\n  defaultLocation {\n    id\n    name\n  }\n}\n\nfragment DeleteItemModal_item on Item {\n  id\n  name\n}\n\nfragment AdditionalFieldInfo_formField on FormField {\n  id\n  name\n  type\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'cf9c1b82aa9bd2e57c89f65459b17283';
module.exports = node;
